// extracted by mini-css-extract-plugin
module.exports = {"item":"breadthofentitylists_item__kbcIO"};